'use client';

import { useState } from 'react';
import { useCacheKey, useOptimizely } from '@libs/common-next';
import { CacheKey } from './cache-key';
import { Fold } from './fold';
import { Tabs } from './tabs';
import { Flags } from './flags';

export function DevTools() {
    const ck = useCacheKey();
    const { instance } = useOptimizely();
    const [tab, setTab] = useState('Feature flags');
    const debug = ck.headers.has('x-petm-ts-debug');
    const dataFile = JSON.parse(instance?.getOptimizelyConfig()?.getDatafile() ?? '{}');

    if (!debug || !Object.keys(dataFile).length) return null;

    return (
        <Fold>
            <Tabs value={tab} onChange={setTab} />

            {tab === 'Feature flags' && <Flags dataFile={dataFile} />}
            {tab === 'Cache Key' && <CacheKey />}
        </Fold>
    );
}
